import React, { useState, useRef } from "react";
import classNames from "classnames";

const ColorButton = ({ onClick, color, onlyColor, buttonRef }) => {
  const isTransparent = color === "transparent";

  const btnClasses = classNames("btn btn-form btn-color", {
    "btn-color--transparent": isTransparent,
    "btn-full-width": onlyColor
  });

  const previewStyle = isTransparent ? {} : { background: color };

  return (
    <button className={btnClasses} onClick={onClick} ref={buttonRef}>
      <span style={previewStyle}></span>
    </button>
  );
};

export default ColorButton;
